import axiosInstance from "./axiosInstance";

export async function createAspekOperasional(data) {
  return await axiosInstance.post("/aspek-operasional", data);
}

export async function updateAspekOperasional(data) {
  return await axiosInstance.put("/aspek-operasional", data);
}

export async function getAspekOperasionalAll(year,type, startYear,startMonth, endMonth, endYear, perusahaanId) {
  return axiosInstance.get(`indikator-kesehatan/aspek-operasional?type=2&startMonth=0&endMonth=0&perusahaanId=32097ed8-a2cf-4005-ae40-abecbe7f1905&startYear=2021&endYear=2022`);
}

export async function findAspekOperasionalByYearAndMonth({ year, month, perusahaan }) {
  return await axiosInstance.get(`/aspek-operasional/filter?year=${year}&month=${month}&perusahaan=${perusahaan}`);
}
